import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import InfoCircleRegular from './info-circle-regular-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <InfoCircleRegular {...validProps} />;
}
SvgComponent.iconName = 'info-circle-regular';

export const InfoCircleRegularIcon = svgIconWrapper(SvgComponent);
